import { baseUrl } from '../config/Constantes'

export default class LoginService {
 


    login(usuario) {

        var formBody = [];
        for (var property in usuario) {
            var encodedKey = encodeURIComponent(property);
            var encodedValue = encodeURIComponent(usuario[property]);
            formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        return fetch(`${baseUrl}/Auth`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: formBody
        }).then(function (response) {
            return response.json();
        }).catch(error => {
            let { name, message } = error;
            window.localStorage.removeItem('loggedUserId');
            window.localStorage.removeItem('isAdmin');
            if (message.toLowerCase() === 'failed to fetch') message = "Ocorreu um erro. Por favor, tente novamente em instantes."
            throw new Error(message)
        });
    }

}


// WEBPACK FOOTER //
// ./src/services/LoginService.js